module.exports = __webpack_public_path__ + "static/media/WaarVindIkDeCode_Ontwerp2PNG.0a4a52ed.png";